"use strict";

angular.module('app.modals.controlledByScene', [])

    .controller('controlledBySceneModalCtrl', ['$scope', 'close', 'Obj', '__Scene', '__DatapointConfig', '__Datapoint', 'API', 'sceneAugmenterService',
        function ($scope, close, Obj, __Scene, __DatapointConfig, __Datapoint, API, sceneAugmenterService) {
            $scope.Object = Obj;
            $scope.init = function () {
                $scope.Device = $scope.Object.Device;
                if ($scope.Object.Datapoint != undefined) {
                    $scope.scenes = __Scene.$getByDatapointValue($scope.Object.Device.DeviceId, $scope.Object.Datapoint.DatapointValue.DatapointConfigId).$then(function () {
                        // Now Load Configs for DatapointInfoValues
                        var list = [];
                        var configIds = {};
                        for (var i = 0; i < $scope.scenes.length; i++) {
                            for (var j = 0; j < $scope.scenes[i].SceneValueInfoEntries.length; j++) {
                                var Entry = $scope.scenes[i].SceneValueInfoEntries[j];

                                if (!configIds.hasOwnProperty('CID' + Entry.DatapointValue.DatapointConfigId)) {
                                    configIds['CID' + Entry.DatapointValue.DatapointConfigId] = [];
                                }
                                configIds['CID' + Entry.DatapointValue.DatapointConfigId].push(Entry);
                            }
                        }
                        // Get IDS
                        var sendO = {
                            'DeviceId': $scope.Device.DeviceId,
                            'DatapointConfigIds': (Object.keys(configIds)).map(x => x.substr(3))
                        };
                        __DatapointConfig.$ByDeviceId(sendO).$then(function (data) {

                            for (var i = 0; i < data.length; i++) {

                                var DatapointConfigId = data[i].DatapointConfigId;
                                var Datapoint = {

                                    DatapointConfig: data[i]
                                }
                                for (var m = 0; m < configIds['CID' + DatapointConfigId].length; m++) {
                                    Datapoint.DatapointValue = configIds['CID' + DatapointConfigId][m].DatapointValue;


                                    Datapoint.DatapointConfig.$type = data[i]._type;
                                    Datapoint.DatapointValue.$type = data[i]._type.replace('DatapointConfig', 'DatapointValue');
                                    var dp = __Datapoint.$buildRaw(Datapoint);

                                    if (configIds['CID' + DatapointConfigId][m].$UI == undefined) {
                                        configIds['CID' + DatapointConfigId][m].$UI = {};
                                    }
                                    ;
                                    configIds['CID' + DatapointConfigId][m].$UI.$Datapoint = dp.$dispatch('build');
                                }
                            }
                        })
                    });
                } else {
                    $scope.loading = true;
                    const api = new API();
                    const params = { 'DeviceId': $scope.Object.Device.DeviceId };

                    return api.Scene.GetScenesByDeviceId(params).$promise
                    .then(function(scenes) {
                        sceneAugmenterService.augmentScenes(scenes);
                        $scope.loading = undefined;
                        $scope.scenes = scenes;
                    });
                }
                //
            }
            $scope.init();
            $scope.close = function () {
                close();
            };
        }
    ])

    .factory('controlledBySceneModal', ['ModalService', function (ModalService) {
        return function (Obj) {
            ModalService.showModal({
                templateUrl: "views/modals/controlledByScene.html",
                controller: 'controlledBySceneModalCtrl',
                inputs: {
                    Obj: Obj
                }
            })


        }
    }]);
